import { createAnalyticsManager } from './analytics-manager';
import { NullAnalyticsService } from './null-analytics-service';
import { PlausibleAnalyticsService } from './plausible-analytics-service';
import { PostHogAnalyticsService } from './posthog-analytics-service';
import type { AnalyticsManager, AnalyticsProviderFactory } from './types';

const providers: Record<string, AnalyticsProviderFactory<object>> = {
  plausible: () => PlausibleAnalyticsService,
};

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  providers.posthog = () => PostHogAnalyticsService;
} else {
  providers.posthog = () => NullAnalyticsService;
}

export const analytics: AnalyticsManager = createAnalyticsManager({
  providers,
});
